import { SELECT_AN_OPTION_LABEL } from '../../constants/common';

export const PAYMENT_METHOD = (lang) =>
  lang === 'en'
    ? [
        { label: 'Please select payment method', value: null, code: null },
        { label: 'In cash', value: 'CASH', code: '10' },
        { label: "Banker's draft", value: 'BANKERS_DRAFT', code: '21' },
        { label: 'Credit card', value: 'CREDIT_CARD', code: '48' },
        { label: 'Debit card', value: 'DEBIT_CARD', code: '55' },
        { label: 'Cheque', value: 'CHEQUE', code: '20' },
        { label: 'Credit transfer', value: 'CREDIT_TRANSFER', code: '30' },
        { label: 'Direct debit', value: 'DIRECT_DEBIT', code: '49' },
      ]
    : [
        { label: 'اختر طريقة الدفع', value: null, code: null },
        { label: 'نقداً', value: 'CASH', code: '10' },
        { label: 'كمبيالة مصرفية', value: 'BANKERS_DRAFT', code: '21' },
        { label: 'بطاقة ائتمان', value: 'CREDIT_CARD', code: '48' },
        { label: 'بطاقة خصم', value: 'DEBIT_CARD', code: '55' },
        { label: 'شيك', value: 'CHEQUE', code: '20' },
        { label: 'حوالة بنكية', value: 'CREDIT_TRANSFER', code: '30' },
        { label: 'خصم مباشر', value: 'DIRECT_DEBIT', code: '49' },
      ];

export const NOTE_TYPES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Credit Note', value: 'CREDIT' },
        { label: 'Debit Note', value: 'DEBIT' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'إشعار دائن', value: 'CREDIT' },
        { label: 'إشعار مدين', value: 'DEBIT' },
      ];

export const ADDITIONAL_SELLER_ID_TYPES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        {
          label: 'Sub Commercial Registration Number',
          value: 'SUBCRN',
        },
        { label: 'IGA Establishment Number', value: 'IGA' },
        { label: 'Governmental Entity No', value: 'GOVEN' },
        { label: 'Central Population Registry Number', value: 'CPRID' },
        { label: 'Other ID', value: 'OTH' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'رقم السجل التجاري الفرعي', value: 'SUBCRN' },
        { label: 'رقم منشأة IGA', value: 'IGA' },
        { label: 'رقم الكيان الحكومي', value: 'GOVEN' },
        { label: 'رقم السجل المركزي للسكان', value: 'CPRID' },
        { label: 'رقم تعريف آخر', value: 'OTH' },
      ];

export const CITIES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Muscat', value: 'MUSCAT' },
        { label: 'Salalah', value: 'SALALAH' },
        { label: 'Sohar', value: 'SOHAR' },
        { label: 'Nizwa', value: 'NIZWA' },
        { label: 'Sur', value: 'SUR' },
        { label: 'Barka', value: 'BARKA' },
        { label: 'Rustaq', value: 'RUSTAQ' },
        { label: 'Ibri', value: 'IBRI' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'مسقط', value: 'MUSCAT' },
        { label: 'صلالة', value: 'SALALAH' },
        { label: 'صحار', value: 'SOHAR' },
        { label: 'نزوى', value: 'NIZWA' },
        { label: 'صور', value: 'SUR' },
        { label: 'بركاء', value: 'BARKA' },
        { label: 'الرستاق', value: 'RUSTAQ' },
        { label: 'عبري', value: 'IBRI' },
      ];

export const ADDITIONAL_BUYER_ID_TYPES = (lang) =>
  lang === 'en'
    ? [
        { label: 'Select ID type', value: '' },
        { label: 'Tax Identification Number', value: 'TIN' },
        { label: 'Commercial Registration Number', value: 'CRN' },
        { label: 'IGA Establishment Number', value: 'IGA' },
        { label: 'Governmental Entity No', value: 'GOVEN' },
        { label: 'Central Population Registry Number', value: 'CPRID' },
        { label: 'Other ID', value: 'OTH' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'رقم التعريف الضريبي', value: 'TIN' },
        { label: 'رقم السجل التجاري', value: 'CRN' },
        { label: 'رقم منشأة IGA', value: 'IGA' },
        { label: 'رقم الكيان الحكومي', value: 'GOVEN' },

        { label: 'رقم تعريف آخر', value: 'OTH' },
      ];

export const INVOICE_TYPES = (lang) =>
  lang === 'ar'
    ? [
        { label: 'اختر', value: '' },
        { label: 'فاتورة ضريبية', value: 'STANDARD_TAX' },
        { label: 'فاتورة مبسطة', value: 'SIMPLIFIED_TAX' },
      ]
    : [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Standard Tax', value: 'STANDARD_TAX' },
        { label: 'Simplified Tax', value: 'SIMPLIFIED_TAX' },
      ];

export const INVOICE_STATUS = (lang) =>
  lang === 'ar'
    ? [
        { label: 'اختر', value: '' },
        { label: 'مرسلة', value: 'SUBMITTED' },
        { label: 'مرفوضة', value: 'REJECTED' },
        // { label: 'مسودة', value: 'IN_DRAFT' },
      ]
    : [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Submitted', value: 'SUBMITTED' },
        { label: 'Rejected', value: 'REJECTED' },
        // { label: 'Draft', value: 'IN_DRAFT' },
      ];

export const NOTE_ISSUANCE_REASONS = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        {
          label: 'Supply has been cancelled/Returned',
          value: 'RA',
        },
        {
          label:
            'Change in VAT treatment of the supply due to a change in the nature of the supply',
          value: 'RB',
        },
        {
          label: 'Change in value of supply due to amendment of price',
          value: 'RC',
        },
        {
          label: 'Change in value of supply due to amendment in quantity',
          value: 'RD',
        },
        {
          label:
            'Incorrect information on invoice (for example, incorrect buyer information)',
          value: 'RE',
        },
        { label: 'Change in value due to amendment in discount', value: 'RF' },
        { label: 'Change in value due to amendment in charges', value: 'RG' },
        { label: 'Bad debt relief', value: 'RH' },
        {
          label: 'Decrease in value of supply due to damaged goods',
          value: 'RI',
        },
        { label: 'Others', value: 'OTH' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'تم إلغاء/إرجاع الطلب', value: 'RA' },
        {
          label:
            'تغيير في معاملة ضريبة القيمة المضافة للتوريد نتيجة لتغيير في طبيعة التوريد',
          value: 'RB',
        },
        {
          label: 'التغير في قيمة العرض نتيجة لتعديل السعر',
          value: 'RC',
        },
        { label: 'التغير في قيمة العرض نتيجة لتعديل الكمية', value: 'RD' },
        {
          label:
            'معلومات غير صحيحة في الفاتورة (على سبيل المثال، معلومات العميل غير الصحيحة)',
          value: 'RE',
        },
        { label: 'التغير في القيمة نتيجة لتعديل الخصم', value: 'RF' },
        { label: 'تغير القيمة نتيجة لتعديل الرسوم', value: 'RG' },
        { label: 'تخفيف الديون المعدومة', value: 'RH' },
        { label: 'انخفاض قيمة التوريد بسبب البضائع التالفة', value: 'RI' },
        { label: 'غيرها', value: 'OTH' },
      ];

export const PREVIOUS_INVOICES = ({ previousInvoices, language }) => {
  return language === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        ...previousInvoices.map((invoice) => ({
          value: invoice.irn,
          label: invoice.irn,
        })),
      ]
    : [
        { label: 'اختر', value: '' },
        ...previousInvoices.map((invoice) => ({
          value: invoice.irn,
          label: invoice.irn,
        })),
      ];
};

export const EXEMPTION_REASON_CODES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Supply of Financial Services', value: 'VATEX_BH_81_E' },
        {
          label: 'Sale and rent of real estate',
          value: 'VATEX_BH_82_E',
        },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'توريد الخدمات المالية', value: 'VATEX_BH_81_E' },
        { label: 'بيع وإيجار العقارات', value: 'VATEX_BH_82_E' },
      ];

export const ZERO_RATING_REASON_CODES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { value: 'VATEX_BH_67_Z', label: 'Zero-rated export of goods' },
        {
          value: 'VATEX_BH_68_Z',
          label:
            'International transportation of passengers and Goods and related Services',
        },
        { value: 'VATEX_BH_69_Z', label: 'Healthcare Services' },
        {
          value: 'VATEX_BH_70_Z',
          label:
            'Supply of Goods and Services associated to the Supply of Healthcare Services',
        },
        { value: 'VATEX_BH_71_Z', label: 'Medicines and medical equipment' },
        {
          value: 'VATEX_BH_73_Z',
          label: 'Supply of Services to a Non-Resident Customer',
        },
        {
          value: 'VATEX_BH_74_Z',
          label: 'Supply of gold, silver and platinum',
        },
        {
          value: 'VATEX_BH_75_Z',
          label: 'Supply of pearls and precious stones',
        },
        { value: 'VATEX_BH_76_Z', label: 'Construction of new buildings' },
        {
          value: 'VATEX_BH_77_Z',
          label: 'Educational Services and related Goods and Services',
        },
        { value: 'VATEX_BH_78_Z', label: 'Local transportation' },
        { value: 'VATEX_BH_79_Z', label: 'Oil, oil derivatives and gas' },
        { value: 'VATEX_BH_80_Z', label: 'Supply of specific food items' },
        { value: 'VATEX_BH_81_Z', label: 'Special transactions' },
      ]
    : [
        { label: 'اختر', value: '' },
        { value: 'VATEX_BH_67_Z', label: 'تصدير السلع بمعدل صفر' },
        {
          value: 'VATEX_BH_68_Z',
          label: 'النقل الدولي للركاب والبضائع والخدمات ذات الصلة',
        },
        { value: 'VATEX_BH_69_Z', label: 'الخدمات الصحية' },
        {
          value: 'VATEX_BH_70_Z',
          label: 'توريد السلع والخدمات المرتبطة بتوريد الخدمات الصحية',
        },
        { value: 'VATEX_BH_71_Z', label: 'الأدوية والمعدات الطبية' },
        {
          value: 'VATEX_BH_73_Z',
          label: 'توريد الخدمات لعميل غير مقيم',
        },
        { value: 'VATEX_BH_74_Z', label: 'توريد الذهب والفضة والبلاتين' },
        { value: 'VATEX_BH_75_Z', label: 'توريد اللؤلؤ والأحجار الكريمة' },
        { value: 'VATEX_BH_76_Z', label: 'بناء المباني الجديدة' },
        {
          value: 'VATEX_BH_77_Z',
          label: 'الخدمات التعليمية والسلع والخدمات ذات الصلة',
        },
        { value: 'VATEX_BH_78_Z', label: 'النقل المحلي' },
        { value: 'VATEX_BH_79_Z', label: 'النفط ومشتقات النفط والغاز' },
        { value: 'VATEX_BH_80_Z', label: 'توريد مواد غذائية محددة' },
        { value: 'VATEX_BH_81_Z', label: 'معاملات خاصة' },
      ];

export const OUT_OF_SCOPE_REASON_CODES = (lang) =>
  lang === 'en'
    ? [
        { label: SELECT_AN_OPTION_LABEL, value: '' },
        { label: 'Not subject to VAT', value: 'VATEX_BH_OS_O' },
      ]
    : [
        { label: 'اختر', value: '' },
        { label: 'غير خاضع لضريبة القيمة المضافة', value: 'VATEX_BH_OS_O' },
      ];
